// extracted by mini-css-extract-plugin
export default {"root":"Page_root__cFSIj"};